export const DISCORD_LINK = 'https://discord.gg/dexfinance';
export const TELEGRAM_LINK = 'https://t.me/dexfinance';
export const TWITTER_LINK = 'https://x.com/DexFinance';
export const YOUTUBE_LINK = 'https://www.youtube.com/@DexFinance';
export const MEDIUM_LINK = 'https://medium.com/@DexFinance';
